import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ViewRepresentation } from "../../../../store/analytics/Analytics";
import { useView } from "../../../../hooks/useView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faTh } from "@fortawesome/free-solid-svg-icons";

export interface RepresentationSelectorProps {
    viewId: string;
}

export function RepresentationSelector(props: RepresentationSelectorProps) {
    const dispatch = useDispatch();
    const { view } = useView(props.viewId);
    const representation = view?.representation;

    const setRepresentation = (rep: ViewRepresentation) => {
        dispatch({
            type: "analytics/setViewRepresentation",
            payload: {
                viewId: props.viewId,
                representation: rep,
            },
        });
    };

    return (
        <span className="gap-2 tags-reps me-4 d-flex justify-content-center align-items-center">
            <Button
                title="Icons"
                size="sm"
                className={`btn-viz-data-description${representation === "large-icons" ? " selected" : ""}`}
                variant="secondary"
                onClick={() => setRepresentation("large-icons")}
            >
                <FontAwesomeIcon icon={faTh} />
            </Button>
            <Button
                title="Detail list"
                size="sm"
                variant="secondary"
                className={`btn-viz-data-description${representation === "detail-list" ? " selected" : ""}`}
                onClick={() => setRepresentation("detail-list")}
            >
                <FontAwesomeIcon icon={faList} />
            </Button>
        </span>
    );
}
